import * as jose from 'jose';

/**
 * Creates a page title:
 * ```
 * createPageTitle()  // "WorkOS Docs"
 * createPageTitle('Single Sign-On')  // "Single Sign-On – WorkOS Docs"
 * createPageTitle('Example Apps', 'Single Sign-On')  // "Example Apps – Single Sign-On – WorkOS Docs"
 * createPageTitle('Single Sign-On', 'Single Sign-On')  // "Single Sign-On – WorkOS Docs"
 * createPageTitle(undefined, 'Single Sign-On')  // "Single Sign-On – WorkOS Docs"
 * ```
 */
export const createPageTitle = (...titles: (string | undefined)[]) =>
  [...new Set([...titles, 'WorkOS Docs'])].filter(Boolean).join(' – ');

export const createPageDescription = (description?: string) =>
  description ??
  'Documentation on integrating WorkOS API for Single Sign-On (SSO), Directory Sync (SCIM), Admin Portal, and more.';

export const createPageImage = async (
  title = '',
  description = '',
  category = 'Docs',
) => {
  category = category === title ? 'Docs' : category || 'Docs';
  description = description.trim().replace(/\.$/, '');

  const signingKey = process.env.OG_IMAGE_SIGNING_KEY ?? '';

  const imageToken = await new jose.SignJWT({
    category,
    title,
    description,
  })
    .setProtectedHeader({ alg: 'HS256', typ: 'JWT' })
    .setIssuedAt()
    .sign(Buffer.from(signingKey));

  const imageUrl = `https://og-images.workos.com/api/docs/?t=${encodeURIComponent(
    imageToken,
  )}`;

  return imageUrl;
};
